class UsersController {
    static $inject = ["$q", "$location", "stToast", "tpsrService"];

    constructor($q, $location, stToast, tpsrService) {
        this.$q = $q;
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.customer = null;
        this.users = [];
        this.paging = {
            size: 100,
            number: 1,
            totalQty: 0,
            orderBy: "last_name",
            orderDescending: false
        };
        this.showDisabled = false;

        this.isAdmin = this.tpsr.user.is_npc_admin || this.tpsr.user.is_admin;
        this.isManager = this.tpsr.user.is_manager;

        this.showOrders = this.isAdmin || this.isManager;
    }

    $onInit() {
        let customer_id = this.tpsr.user.PIMS_customer_id;
        if (this.tpsr.user.is_npc_admin && this.customerId)
            customer_id = this.customerId;

        return this.$q.all([
            this._loadCustomer(customer_id),
            this._loadUsers(customer_id)
        ]);
    }

    sortClicked = (orderBy, descendingFirst) => {
        if (orderBy === this.paging.orderBy)
            this.paging.orderDescending = !this.paging.orderDescending;
        else
            this.paging.orderDescending = !!descendingFirst;
        this.paging.orderBy = orderBy;
        return this._loadUsers(this.customer.PIMS_customer_id);
    }

    prevPageClicked = () => {
        this.paging.number--;
        return this._loadUsers(this.customer.PIMS_customer_id);
    };

    nextPageClicked = () => {
        this.paging.number++;
        return this._loadUsers(this.customer.PIMS_customer_id);
    };

    showDisabledClicked = () => {
        this.paging.number = 1;
        return this._loadUsers(this.customer.PIMS_customer_id);
    }

    addUserClicked = () => {
        this.$location.url(`/customers/${this.customer.PIMS_customer_id}/users/create`);
    };

    pendingOrdersClicked = () => {
        // Button should only be visible for managers.
        this.$location.url(`/managers/${this.tpsr.user.user_id}/pending-orders`);
    };

    toggleRoleClicked = (user, propName, currVal) => {
        return this.tpsr.userToggleRole(user.user_id, propName, !currVal);
    };

    editClicked = user => {
        this.$location.url(`/users/${user.user_id}`);
    };

    ordersClicked = user => {
        this.$location.url(`/users/${user.user_id}/orders`);
    };

    pwResetClicked = user => {
        user.passwordResetSent = true;
        if (user.has_password) {
            return this.tpsr.resetPasswordRequest({ email: user.email })
                .then(result => {

                });
        } else {
            return this.tpsr.createUserEmailRequest({ email: user.email })
                .then(result => {

                });
        }
    };

    _loadCustomer = customer_id => {
        return this.tpsr.getCustomer(customer_id).then(result => this.customer = result);
    }

    _loadUsers = customer_id => {
        let manager_id = null;
        if (this.tpsr.user.is_manager && !this.tpsr.user.is_admin)
            manager_id = this.tpsr.user.user_id;

        return this.tpsr.getUsers(this.paging.size, this.paging.number, this.paging.orderBy, this.paging.orderDescending, customer_id, manager_id, this.showDisabled)
            .then(result => {
                this.users = result.users;
                this.paging.totalQty = result.totalQty;

                this.users.forEach(u => u.passwordResetSent = false);
            });
    };
}

angular
    .module("app")
    .component("users", { // users
        bindings: {
            customerId: "<"
        },
        templateUrl: "src/app/users/users.html",
        controller: UsersController
    });
